import { Box, Typography, Stack, Divider } from '@mui/material';
import { Field, useFormikContext } from 'formik';
import FormDatePicker from './FormDatePicker';
import { EventFormValues } from 'src/schema';

interface EventDatePickersProps {
    values: EventFormValues;
}

export default function EventDatePickers({ values }: EventDatePickersProps) {
    const { setFieldValue, setFieldTouched } = useFormikContext<EventFormValues>();

    console.log('EventDatePickers', values);

    // Watch for changes to startDate
    const handleStartDateChange = (date: Date | null) => {
        setFieldValue('startDate', date);
        setFieldTouched('startDate').catch(console.error);

        // If startDate is cleared, also clear endDate
        if (date === null && values.endDate) {
            setFieldValue('endDate', null);
            setFieldTouched('endDate').catch(console.error);
        }

        // If new startDate is after endDate, clear endDate
        if (date && values.endDate && date > values.endDate) {
            setFieldValue('endDate', null);
            setFieldTouched('endDate').catch(console.error);
        }
    };

    // Watch for changes to endDate
    const handleEndDateChange = (date: Date | null) => {
        setFieldValue('endDate', date);
        setFieldTouched('endDate').catch(console.error);
    };

    return (
        <Box mt={2}>
            <Divider sx={{ width: '100%', mb: 2 }} />
            <Stack direction="column" spacing={1} sx={{ position: 'relative' }}>
                <Typography variant="h6" sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                    Event Dates
                </Typography>

                <Field
                    name="startDate"
                    component={FormDatePicker}
                    label="Start Date"
                    placeholderText="Select start date"
                    onChange={handleStartDateChange}
                />

                {values.startDate && (
                    <Field
                        name="endDate"
                        component={FormDatePicker}
                        label="End Date"
                        placeholderText="Select end date"
                        minDate={values.startDate}
                        onChange={handleEndDateChange}
                    />
                )}
            </Stack>
        </Box>
    );
}
